module.exports = __webpack_public_path__ + "static/media/chipping-example.5eb23c94.png";